import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/Pabrik.css";
import axios from "axios";

const PabrikHLD = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); 
  const [data, setData] = useState(null); 
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null); 
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const resData = response.data;
        if (!resData.error) {
          setUserInfo({
            role: resData.role,
            name: resData.name,
            full_name: resData.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      alert("Gagal logout. Silakan coba lagi.");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://c-greenproject.org:7500/produksi_pabrik_detail",
          {
            params: { id },
            withCredentials: true,
          }
        );

        if (response.status === 200 && response.data) {
          const hasil = Array.isArray(response.data)
            ? response.data[0]
            : response.data;
          setData(hasil);
        } else {
          setError("Data tidak ditemukan.");
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Gagal mengambil data dari server.");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchData();
  }, [id]);

  const formatNumber = (num) => {
    if (num === null || num === undefined || isNaN(num)) return "-";
    return Number(num).toLocaleString("id-ID");
  };

  if (loading) {
    return (
      <div className="text-center py-5 bg-light min-vh-100 d-flex flex-column justify-content-center align-items-center">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="text-muted mt-2">Memuat detail produksi...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container py-5 text-center">
        <div className="alert alert-danger rounded-3 p-4 shadow-sm">
          <h4 className="fw-bold">Terjadi Kesalahan</h4>
          <p className="mb-3">{error}</p>
          <button className="btn btn-success rounded-pill px-4" onClick={handleBack}>Kembali</button>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* Header */}
      <div className="header">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-success btn-sm rounded-pill px-3"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3">
          <p>Portal Sistem Traceability</p>
          <h6>Telsa Super Apps</h6>
          <p>
            <img src="/static/schedule_11145854.png" alt="Date" />
            {tanggal}
          </p>
          <div className="list-group list-group-flush">
            <div
              onClick={() => navigate("/pabrik")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/pabrik" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/pabrik" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/pabrikt")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/pabrikt" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/pabrikt" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/shipping.png" alt="Planting" /> Transaksi
            </div>
            <div
              onClick={() => navigate("/pabrikh")}
              className={`list-group-item text-decoration-none ${
                location.pathname.includes("/pabrikh")
                  ? "active text-white"
                  : ""
              }`}
              style={{
                color: location.pathname.includes("/pabrikh") ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/packaging.png" alt="Harvest" /> Hasil
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-bold text-dark mb-1">Detail Hasil Produksi</h2>
              <p className="text-muted small mb-0">Informasi lengkap ID Produksi: <span className="font-monospace fw-bold text-success">#{id}</span></p>
            </div>
            <button
              className="btn btn-outline-secondary rounded-pill px-4 shadow-sm fw-medium"
              onClick={handleBack}
            >
              <i className="fa fa-arrow-left me-2"></i>Kembali
            </button>
          </div>

          <div className="divider mb-4"></div>

          {/* Detail Modern Card */}
          {data && (
            <div className="row g-4">
              
              {/* Card Utama: Hasil CPO & Info Pabrik */}
              <div className="col-lg-6">
                <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white h-100 d-flex flex-column justify-content-between">
                  <div>
                    <h4 className="fw-bold text-success mb-3">Ringkasan Produksi</h4>
                    
                    {/* Banner Hasil CPO */}
                    <div className="p-4 bg-success-subtle rounded-4 border border-success-subtle mb-4 d-flex align-items-center justify-content-between">
                      <div>
                        <span className="text-success-emphasis fw-semibold small d-block mb-1">TOTAL HASIL CPO</span>
                        <h2 className="font-monospace fw-bold text-success mb-0">{formatNumber(data.hasil_cpo)} kg</h2>
                      </div>
                      <div className="bg-success text-white p-3 rounded-circle shadow-sm">
                        <i className="fa fa-oil-can fs-4"></i>
                      </div>
                    </div>

                    {/* Informasi Umum */}
                    <div className="mb-3">
                      <span className="text-muted small d-block mb-1">Nama Pabrik</span>
                      <h6 className="fw-bold text-dark mb-0">{data.nama_pabrik || "-"}</h6>
                    </div>
                    <div className="mb-3">
                      <span className="text-muted small d-block mb-1">Sumber Produksi</span>
                      <h6 className="fw-semibold text-secondary font-monospace mb-0">{data.sumber_produksi || "-"}</h6>
                    </div>
                    <div className="mb-0">
                      <span className="text-muted small d-block mb-1">Waktu Produksi</span>
                      <h6 className="fw-semibold text-muted mb-0">{data.waktu_produksi || "-"}</h6>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card Kedua: Rincian Limbah Produksi */}
              <div className="col-lg-6">
                <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white h-100">
                  <h4 className="fw-bold text-success mb-3">Rincian Limbah Produksi</h4>
                  
                  {data.limbah_produksi && Object.keys(data.limbah_produksi).length > 0 ? (
                    <div className="table-responsive border rounded-3 overflow-hidden">
                      <table className="table table-hover table-striped mb-0 align-middle">
                        <thead className="table-light">
                          <tr>
                            <th className="py-3 px-3 fw-semibold">Jenis Limbah</th>
                            <th className="py-3 px-3 text-end fw-semibold">Jumlah (kg)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.entries(data.limbah_produksi).map(([key, value], index) => (
                            <tr key={index}>
                              <td className="py-3 px-3 text-capitalize fw-medium text-dark">{key.replace(/_/g, " ")}</td>
                              <td className="py-3 px-3 text-end font-monospace fw-bold text-secondary">{formatNumber(value)} kg</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center py-5 text-muted bg-light rounded-3">
                      <i className="fa fa-info-circle mb-2 opacity-50 fs-3"></i>
                      <p className="mb-0 fst-italic">Tidak ada data limbah tersedia.</p>
                    </div>
                  )}
                </div>
              </div>

            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PabrikHLD;